export default __webpack_public_path__ + "static/media/Reyz_logo.729238bc.webp";